module.exports = __webpack_public_path__ + "static/img/user_photo.2486777.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/user_photo.jpeg
// module id = 129
// module chunks = 1